<template>
  <v-radio
    class="bm-radio"
    v-bind="$attrs"
    :value="value"
    :label="labelVal"
    :data-qa="dataQa"
    @change="handleChange($event)"
  ></v-radio>
</template>

<script lang="ts">
import BmLabelled from "@/components/controls/input/mixins/BmLabelled";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmRadio",
  inheritAttrs: false,
  mixins: [BmLabelled],
  props: {
    value: {
      required: false,
    },
  },
  methods: {
    handleChange(evt: any) {
      this.$emit("input", evt);
    },
  },
});
</script>

<style scoped lang="sass">
@import "src/sass/typography"

.bm-radio :deep(label.v-label)
  @include bm-body

.bm-radio.v-radio--is-disabled :deep(label.v-label)
  color: rgba(#000000, .38)!important
</style>
